import fetchDownload from '../../../services/GetDownload.jsx';
import { DownloadFileFunc } from '../../../types';
import buildDownloadEndpoint from '../../../utils/buildDownloadEndpoint';

export async function fetchDownloadFile({
  extension,
  columnVisibilityModel,
  view,
  source,
  tab,
  searchItems,
  titleGrid,
  isAuthenticated,
  authorization,
  isEvidence,
  isMapping,
  mappingContent,
}: DownloadFileFunc): Promise<void> {
  let url = buildDownloadEndpoint({
    extension,
    columnVisibilityModel,
    view,
    source,
    tab,
    searchItems,
    isEvidence,
    isMapping,
    mappingContent,
  });

  if (!isAuthenticated) {
    url += '&skey=unauth';
  }

  const blob = await fetchDownload(url, authorization);
  const blobUrl = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = blobUrl;

  const fileName = `${view}_${titleGrid}_${tab}_${source}_${searchItems!.map(i => i.id).join('-')}.${extension}`;
  link.setAttribute('download', fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
